import { createSlice } from "@reduxjs/toolkit";
import { getColoursList } from "../../reduxApi/admin/ColourReduxApi";

const colourSlice = createSlice({
    name: 'colour',
    initialState: {
        status: 'idel',
        isFiltered: false,
        colour: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteColourAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.colour.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.colour.splice(index, 1);
                }
            });
        },
        updateColourAction: (state, action) => {
            const index = state.colour.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.colour.splice(index, 1, { colours: action.payload })
            }
        },
        addColourAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.colour.unshift({ colours: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getColoursList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getColoursList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.colour = action.payload.data.colours;
            })
    }
})
export const { deleteColourAction, updateColourAction, addColourAction, setFilteredStatus } = colourSlice.actions
export default colourSlice.reducer